import React from 'react';
import { getTeamEventUrl, getFriendlyTeamName, getLineHistoryUrl } from '../../utils/gameUtils';
import {
    Link,
    useParams,
} from "react-router-dom";
import { formatGameTime } from '../../utils/timeFormat'
import AllIcon from './images/All.png';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { TeamImage as TeamImageWrapper } from '../odds/TeamImage';
import FullGameImage from './images/FullGame.png'
const styles = makeStyles(theme => ({
    container: {
        display: 'grid',
        /* width: '90%',*/
        height: '100%',
        gridTemplateColumns: '30px auto',
        gridTemplateRows: 'repeat(3,1fr)',
        justifyItems: 'left',
        alignItems: 'center',
        backgroundColor: 'white',
        backgroundClip: 'border-box',
        [theme.breakpoints.up("sm")]: {
            gridTemplateColumns: '90px auto 50%',
            gridTemplateRows: '1fr 1fr',
        },
        [theme.breakpoints.up('lg')]: {
            paddingLeft: 0,
        },
    },
    teamName: {
        fontSize: 14,
        fontWeight: 600,
        letterSpacing: '0.3px',
        textAlign: 'left',
        [theme.breakpoints.down('sm')]: {
            fontSize: 14,
        },
        "& p": {
            color: 'black !important',
        },
        marginLeft: 4,
        justifySelf: 'start',
        marginBottom: 0,
        marginTop: 0,
    },
    teamImage: {
        marginTop: 0,
        width: 30,
        height: 30,
        objectFit: 'contain',
    },
    gameDate: {
        fontSize: 12,
        marginLeft: 0,
        marginTop: 0,
        marginBottom: 0,
        fontWeight: 400,
        textAlign: 'center',
        gridColumn: "1 / 3",
        display: 'flex',
        alignItems: 'center',
        color: 'black',
        [theme.breakpoints.down("sm")]: {
            gridColumn: '1 / 3 ',
            marginLeft: '24px',
        },
        [theme.breakpoints.up("sm")]: {
            marginTop: 0,
            marginLeft: 0,
            fontSize: '14px',
            fontWeight: 600,
            gridColumn: 'auto'
        }
    },
    secondTeam: {
        marginBottom: '5px'
    },
    mobileAllButton: {
        gridColumn: '1 / 3',
    },
    allButton: {
        height: '28px',
        '& img': {
        },
        display: 'flex',
        flexDirection: 'row',
    }
}));

export function TeamMatchup({ game }) {
    const classes = styles();
    const theme = useTheme();
    const isLargeScreen = useMediaQuery(theme.breakpoints.up('sm'));
    const { league } = useParams();

    const homeTeam = game.competitors['home'];
    const awayTeam = game.competitors['away'];
    var gameTimeDate = new Date(game['scheduled_datetime']);
    var gameTime = formatGameTime(gameTimeDate);

    let url = getTeamEventUrl(league, game);
    let lineHistoryUrl = getLineHistoryUrl(league, game);

    if (isLargeScreen) {
        return (
            <Link to={url}>
                <div className={classes.container}>
                    <GameDate gameStatus={game.status} gameTime={gameTime} />
                    <TeamImage competitor={awayTeam} league={league} />
                    <TeamName competitor={awayTeam} league={league} />
                    <div className={classes.allButton}>
                        <img alt="all" src={AllIcon} width={35} style={{objectFit: 'contain'}} />
                        <Link to={lineHistoryUrl} >
                            <img alt="line history button" src={FullGameImage} width={16} style={{ marginTop: 7, marginLeft: 5 }} />
                        </Link>
                    </div>
                    <TeamImage competitor={homeTeam} league={league} />
                    <TeamName competitor={homeTeam} league={league} />
                </div>
            </Link>
        );
    }

    return (
        <Link to={url}>
            <div className={classes.container}>
                <TeamImage competitor={awayTeam} league={league} />
                <TeamName competitor={awayTeam} league={league} />
                <TeamImage className={classes.secondTeam} competitor={homeTeam} league={league} />
                <TeamName className={classes.secondTeam} competitor={homeTeam} league={league} />
                <GameDate gameStatus={game.status} gameTime={gameTime} />
            </div>
        </Link>
    );
}

const TeamName = ({ competitor, league }) => {
    const classes = styles();
    return <p className={classes.teamName}>
        {getFriendlyTeamName(league, competitor)}
    </p>
}

const TeamImage = ({ competitor, league }) => {
    const classes = styles();

    return <TeamImageWrapper className={classes.teamImage} competitor={competitor} league={league} />
}


const GameDate = ({ gameStatus, gameTime }) => {
    const classes = styles();
    const isPostponed = gameStatus === 'postponed';

    const isCancelled = gameStatus === 'cancelled';

    const isClosed = gameStatus === 'complete';

    return <div className={classes.gameDate}>{isPostponed ? 'Postponed' : isCancelled ? 'Cancelled' : isClosed ? 'Closed' : gameTime.toString()}</div>
}